import FooterCondensed from './FooterCondensed';

export default FooterCondensed;
